import { z } from 'zod';

import { integerAndFloatNumbersRegex } from 'constants/regex';

const amountMaxValue = 99999.99;

const validationSchema = z.object({
  ticketId: z.string(),
  amount: z
    .string()
    .min(1, 'Please enter a valid Amount')
    .regex(integerAndFloatNumbersRegex, { message: 'Only integer or float numbers allowed' })
    .refine(
      val => {
        const amountValue = parseFloat(val);
        return amountValue <= amountMaxValue;
      },
      { message: 'Please enter an amount less than or equal to 99999.99' }
    ),
  claimStatusId: z
    .number({ required_error: 'Please select a Claim status' })
    .min(0, 'Please select a Claim status'),
  claimSubmittedDate: z.date().nullable().optional(),
  advisorNumber: z
    .string()
    .max(50, 'Advisor number must not exceed 50 characters.')
    .nullable()
    .optional(),
  techNumber: z
    .string()
    .max(50, 'Tech number must not exceed 50 characters.')
    .nullable()
    .optional(),
  ticketPriorityId: z
    .number({ required_error: 'Please select a Priority' })
    .min(0, 'Please select a Priority'),
  subCategoryId: z.number().nullable().optional(),
  dmsScheduleAccountNumber: z
    .string()
    .max(100, 'DMS Schedule Account Number must not exceed 100 characters.')
    .optional(),
});

export default validationSchema;
